import './location.css';
import cafeImg from '../../assets/cafe.png';

function ArrowLeftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M11 6l-6 6 6 6" stroke="#3d2f7a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PinIcon({ color = '#6c4ce8', size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 22s7-6.4 7-12a7 7 0 0 0-14 0c0 5.6 7 12 7 12Z" stroke={color} strokeWidth="1.9" strokeLinejoin="round" />
      <circle cx="12" cy="10" r="2.4" stroke={color} strokeWidth="1.9" />
    </svg>
  );
}

function SprigIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 21c0-6 3-10 8-12-6 0-8 3-8 7M12 21c0-6-3-10-8-12 6 0 8 3 8 7" stroke="#8b6cf0" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function CupIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M5 9h11v5a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9Z" stroke="#6c4ce8" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M16 10h1.5a2.5 2.5 0 0 1 0 5H16" stroke="#6c4ce8" strokeWidth="1.8" />
      <path d="M8 3c-.7 1 .7 2 0 3M11.5 3c-.7 1 .7 2 0 3" stroke="#6c4ce8" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function BeanIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <ellipse cx="12" cy="12" rx="8" ry="6" transform="rotate(-30 12 12)" stroke="#6c4ce8" strokeWidth="1.8" />
      <path d="M8 15c2-1 3-3 3-5s-1-4-3-5" stroke="#6c4ce8" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function ChairsIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M4 5v9M9 5v9M4 9h5M4 14l-1 5M9 14l1 5" stroke="#6c4ce8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 5v9M20 5v9M15 9h5M15 14l-1 5M20 14l1 5" stroke="#6c4ce8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function HeartIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 20s-7-4.35-9.5-8.5C.5 8 2 4.5 5.5 4.5 8 4.5 12 7 12 7s4-2.5 6.5-2.5C22 4.5 23.5 8 21.5 11.5 19 15.65 12 20 12 20Z" stroke="#6c4ce8" strokeWidth="1.9" strokeLinejoin="round" />
    </svg>
  );
}

const FEATURES = [
  { icon: <CupIcon />, label: 'Cozy Ambience' },
  { icon: <BeanIcon />, label: 'Premium Beans' },
  { icon: <ChairsIcon />, label: 'Best Place to Relax' },
];

export default function Location({
  onBack,
  onMap,
  shopName = 'Brew House',
  address = 'Downtown Avenue',
  description = 'A warm and cozy place to enjoy your favorite Coffee.',
}) {
  const handleMap = () => {
    if (onMap) {
      onMap();
      return;
    }
    const query = encodeURIComponent([shopName, address].filter(Boolean).join(' '));
    window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="location-screen">
      <div className="location-frame">
        <div className="location-topbar">
          <button type="button" className="location-back-btn" aria-label="Go back" onClick={onBack}>
            <ArrowLeftIcon />
          </button>
        </div>

        <div className="location-header">
          <span className="location-eyebrow">
            <SprigIcon />
            Next Destination
            <SprigIcon />
          </span>
          <h1 className="location-name">{shopName}</h1>
          <p className="location-address">
            <PinIcon size={15} />
            {address}
          </p>
        </div>

        <div className="location-hero">
          <img src={cafeImg} alt={shopName} className="location-hero-img" />
        </div>

        <div className="location-card">
          <p className="location-desc">{description}</p>

          <div className="location-features">
            {FEATURES.map((f) => (
              <div className="location-feature" key={f.label}>
                <span className="location-feature-icon">{f.icon}</span>
                <span className="location-feature-label">{f.label}</span>
              </div>
            ))}
          </div>

          <div className="location-actions">
            <button type="button" className="location-visit-btn" onClick={handleMap}>
              <span className="location-visit-icon">
                <PinIcon color="#ffffff" size={18} />
              </span>
              Map
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
